import { combineReducers } from 'redux';
import fetch from './fetch';
import serviceBookings from './bookings';

export default combineReducers({
  fetch,
  serviceBookings,
});
